import { Paragraph, SizableText, SmartLink, Stack, YStack, isWeb, shadowStandard } from '@my/ui'
import { ArticleCategoryTag } from '../../components'
import { SolitoImage } from 'solito/image'

interface ArticleCardFeaturedProps {
  id: string
  title: string
  shortDescription: string
  featuredImage?: {
    url: string
    alt: string
  }
  primaryCategory: {
    name: string
    slug: string
  }
  slug: string
  imagePriority?: boolean
}

export const ArticleCardFeatured = (props: ArticleCardFeaturedProps) => {
  return (
    <YStack
      className="ArticleCardFeatured"
      position="relative"
      flex={1}
      height="100%"
      borderRadius="$3"
      overflow="hidden"
      backgroundColor="$white"
      {...shadowStandard}
    >
      <YStack flex={1} $gtMd={{ flexDirection: 'row-reverse' }}>
        <SmartLink
          Component={YStack}
          aria-label='View article'
          tabIndex={-1}
          href={`/life/${props.slug}`}
          flex={1}
          $gtMd={{ width: '50%' }}
          pressStyle={{
            opacity: 0.85,
          }}
          hoverStyle={{
            opacity: 0.95,
          }}
        >
          {props.featuredImage && (
            <Stack overflow="hidden" aspectRatio={16 / 9} $gtMd={{ aspectRatio: 1 }}>
              <SolitoImage
                src={props.featuredImage.url}
                alt={props.featuredImage.alt || props.title}
                sizes="(max-width: 900px) 100vw, 446px"
                fill
                contentFit="cover"
                priority={props.imagePriority}
              />
            </Stack>
          )}
        </SmartLink>

        <YStack
          flex={1}
          gap="$3.5"
          p="$3.5"
          $gtSm={{ p: '$6' }}
          $gtMd={{ width: '50%', jc: 'center' }}
        >
          <SmartLink
            position={isWeb ? ('static' as 'relative') : 'relative'}
            Component={Stack}
            href={`/life/${props.slug}`}
            gap="$2"
            pressStyle={{
              opacity: 0.85,
            }}
            hoverStyle={{
              opacity: 0.85,
            }}
            focusStyle={{
              opacity: 0.75,
            }}
          >
            <Stack pos="absolute" w="100%" h="100%" top={0} left={0} zIndex="$1" />
            <SizableText
              tag="h3"
              size="$7"
              fow="700"
              color="$overlay12"
              $gtSm={{ size: '$8', fow: '700' }}
            >
              {props.title}
            </SizableText>
            <Paragraph size="$5" color="$overlay11">
              {props.shortDescription}
            </Paragraph>
          </SmartLink>
          {props.primaryCategory?.name && (
            <ArticleCategoryTag
              alignSelf="flex-start"
              mt="$0"
              zIndex="$2"
              name={props.primaryCategory.name}
              href={`/life/categories/${props.primaryCategory.slug}`}
            />
          )}
        </YStack>
      </YStack>
    </YStack>
  )
}
